module.exports = __webpack_public_path__ + "static/footer-c44a30c5c9b205c3e4f7dea1d327c981.png";